import React from "react"
import { Layout, SEO } from "src/components/common"
import {
  Intro,
  Customers,
  Services,
  Process,
  Projects,
  Quotes,
  About,
  Contact,
  Faq,
  StickyCta,
} from "src/components/landing"

const IndexPage = () => (
  <Layout>
    <SEO />
    <Intro />
    <Customers />
    <Services />
    <Process />
    <Projects />
    <Quotes />
    <About />
    <Faq />
    <Contact />
    <StickyCta />
  </Layout>
)

export default IndexPage
